
import { PublicBandasClient } from "@/components/bandas/PublicBandasClient";
import { db } from "@/firebase/config";
import { Banda } from "@/lib/types";
import { collection, getDocs, onSnapshot, query, orderBy } from 'firebase/firestore';
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { sanitizeFirestoreData } from "@/lib/utils";

export default function BandasPage() {
  const [bandas, setBandas] = useState<Banda[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Set up a real-time listener for the 'bandas' collection
    const q = query(collection(db, "bandas"), orderBy("nombreCompleto"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const bandasData = querySnapshot.docs.map(doc => sanitizeFirestoreData({ id: doc.id, ...doc.data() })) as Banda[];
      setBandas(bandasData);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching bandas for public page:", error);
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-16 w-16 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <main>
        <PublicBandasClient initialBandas={bandas} />
    </main>
  );
}
